import React from 'react'
import { Modal } from 'antd'
import { useDispatch, useSelector } from 'react-redux'
import customLanguageTexts from '../../../language'
import './index.css'

const ModalAppHipaaUSCreated = () => {
  const settings = useSelector(state => state.settings)
  const dispatch = useDispatch()
  const handleCancel = () => {
    dispatch({
      type: 'settings/CHANGE_SETTING',
      payload: {
        setting: 'visibleModalID',
        value: '',
      },
    })
  }
  const { visibleModalID } = settings
  const modalID = 'appHipaaUSCreated'
  const visible = modalID === visibleModalID
  return (
    <Modal
      className="custom__success__modal"
      title={<div>{customLanguageTexts.US_HIPAA_APP_REQUEST_SUCCESS_MSG_HEADER}</div>}
      onCancel={handleCancel}
      afterClose={handleCancel}
      open={visible}
      footer={false}
      maskClosable={false}
    >
      <div className="p-0">
        <div>
          <div> {customLanguageTexts.US_HIPAA_APP_REQUEST_SUCCESS_MSG_BODY}</div>
        </div>
      </div>
    </Modal>
  )
}

export default ModalAppHipaaUSCreated
